import { useState, useEffect } from "react";

import { LAST_SELECTED_CLIENT_GROUP_KEY } from "../../utils/check-utils";

interface Group {
  id: string;
  name: string;
}

export function useGroupSelection(groups: Group[] | undefined) {
  const [selectedGroup, setSelectedGroup] = useState<string | null>(
    localStorage.getItem(LAST_SELECTED_CLIENT_GROUP_KEY)
  );

  useEffect(() => {
    if (!selectedGroup && groups?.length) {
      setSelectedGroup(groups[0].id);
    }
  }, [groups, selectedGroup]);

  const handleGroupChange = (key: string) => {
    setSelectedGroup(key);
    localStorage.setItem(LAST_SELECTED_CLIENT_GROUP_KEY, key);
  };

  return {
    selectedGroup,
    handleGroupChange,
  };
}
